export default ($promise) => {
  return new Promise(function(resolve, reject) {
    $promise.then(resolve, reject);
   });
};
